import { useState } from 'react';

import KondoHeader from '../Header';
import KondoFooter from '../Footer';
import ContactButton from '../ContactButton'
import Pankuzu from '../pankuzu';
import YTube from '../Youtube';
import YTubeOrg from '../YoutubeOrg'
import PrivacyTop from "../../images/ArticleTop.png";
import Spirit_contentTop from "../../images/Spirit_contentTop.png"
import Spirit_cirtificate from "../../images/Spirit_cirtificate.png"
import contents_somemono from "../../images/contents_somemono.png";
import Articleimg_01 from "../../images/Articleimg_01.png"
import Articleimg_02 from "../../images/Articleimg_02.png"
import Articleimg_03 from "../../images/Articleimg_03.png"
import Articleimg_04 from "../../images/Articleimg_04.png"
import Articleimg_06 from "../../images/Articleimg_06.png"
import Articleimg_08 from "../../images/Articleimg_08.png"

// animation
import {motion} from "framer-motion"


const PageArticle = () => {

    const [toggleState, setToggleState] = useState(0); 

    const toggleTab = (index: number) => {
        setToggleState(index);
        console.log(index);
    }

    return(
        <div id="PageKondou">  
            <div id="PageArticle">
                <KondoHeader />
                <motion.div
                    animate={{
                        y: 0,
                        opacity: 1
                    }}
                    initial={{
                        y: 0,
                        opacity: 1
                    }}
                    exit={{
                        y: 100,
                        opacity: 0
                    }}
                    transition={{
                        duration: 0.4,
                        ease: "easeOut",
                    }}
                >
                    <main>
                        <section className='article-top'>
                            <img src={PrivacyTop} className="article-top-img" alt='染の心のトップ' />
                            <Pankuzu pagename="染の心" />
                            <article>
                                <h1>SPIRIT</h1>
                                <h2>近藤の染の心</h2>
                                <img src={Spirit_contentTop} alt='遠永業家' />
                                <div>
                                    <h1>家業永遠の息吹</h1>
                                    <p>
                                        創業明治31年。藍染めからスタートしました。<br/>
                                        徳島から旭川へ開拓移民として入った初代の近藤仙蔵が、1898年に現在の場所で〈近藤染舗〉として創業。<br/>
                                        徳島は藍の産地だったこともあり、冬はとてもしばれる（冷え込む）旭川でも、1936年まで藍染めをしていました。<br/>
                                        家訓「家業永遠」の精神を守り続け、戦後より大漁旗で代を継ぎ、現在もまだ近藤染工場は進化し続けています。
                                    </p>
                                    <img src={Spirit_cirtificate} alt='賞状' />
                                </div>
                            </article>
                        </section>
                        <section className='language-trans'>
                            <article>
                                <div className={toggleState === 0 ? "toggle-active" : "toggle-passive"}>
                                    <h2>「刷毛引き」本染め一筋に、こだわり貫く近藤染工場</h2>
                                    <p>
                                        伝統の技と心を今に受け継ぐ，近藤染工場の本染め。本染めと称して簡易な染色技法が流通し，量産向きの機械染めが氾濫する時勢にあって私達は，白い布に命を吹き込むように職人がひと刷毛ひと刷毛手染めしていく「刷毛引き」の本染めを頑固に守り通しています。
                                    </p>
                                    <p>
                                        刷毛引き本染めは，古くから様々な形で日本人の暮らしを彩ってきた伝統工芸の文化です。裏表なく染め上がる本染めならではの美しさと温もりのある風合いの中に，人々は慶祝や祈願の心を託してきました。
                                    </p>
                                    <p>
                                        見る人を惹きつける，繊細で鮮やかな染め色。掲げる人，纏う人の心意気を伝える，堂々の風格と質感。近藤染工場は，染めを通して人と人，心と心をつなぐ手仕事を生業にしています。
                                    </p>
                                </div>
                                <div className={toggleState === 1 ? "toggle-active" : "toggle-passive"}>
                                    <h2>We have an unwavering passion and devotion to brush dyeing.This is our specialty. This is the Kondo-some workshop.</h2>
                                    <p>
                                        We follow in the footsteps of our predecessors in the effort to preserve our traditional brush dyeing techniques and the spirit that goes into it. This simple dyeing technique called “Brush Dyeing” has been widely circulated throughout Japan. Our artisans start with a single white cloth and breathe life into it through the brush, dyeing it stroke by stroke. Despite living in a time where modern machinery floods the market with mass-produced dyed goods, no matter how stubborn it may seem we will continue to preserve our traditional way of dyeing fabrics. 
                                    </p>
                                    <p>
                                        Brush dyeing is a traditional craft that is culturally significant in colorfully depicting the lives of Japanese people in various forms. A fabric dyed fully through on two sides, a trait characteristic of brush dyeing, emanates an aura of beauty and warmth. On this fabric, we are then entrusted with illustrating the prayers and encouraging words of the people.
                                    </p>
                                    <p>
                                        Distinguished by their detailed illustrations and vivid colors, these pieces allure all that set eyes upon them. We convey the spirit of those who wear the happi coats and those who raise the flags through the texture of the dyes and the style of the design. Through our work, the Kondo-some workshop connects people and connects hearts. It’s our way of life.
                                    </p>
                                </div>
                                <div className={toggleState === 2 ? "toggle-active" : "toggle-passive"}>
                                    <h2>近藤染工場 堅持傳統「刷毛染技法」<br/>
                                    一貫純手工染色技藝</h2>
                                    <p>
                                        近藤染工場至今依舊傳承傳統手工染色技藝。 在現今四處充斥著為因應大幅產量而衍生而出的機械式染坊中，唯有近藤堅持兼持著傳統純手工染色技藝「刷毛染技法」從一而終，技師們遵循古法一毛一刷專注纖細地上染顏色，猶如在白色布料上付與生命一般。
                                    </p>
                                    <p>
                                        刷毛染技，是一項自古以來憑藉著各種樣式呈現彩繪出日本人生活形態的傳統工藝文化。 表裏合一的手工技藝染法結合著美與人情風味繼而寄託出人們的歡祝和祈願之心。
                                    </p>
                                    <p>
                                        纖細且鮮艷的染彩吸引人們的目光。透過掌旗人及身著法被服的人們的一舉一動即可將其凜凜堂堂的風格及質感傳至人心。近藤染工場透過染色手工技藝結合人心，拉進彼此的距離。
                                    </p>
                                </div>
                                <div className={toggleState === 3 ? "toggle-active" : "toggle-passive"}>
                                    <h2>솔질 본염의 외길, 전통의 기법을  관철하는 곤도염색공장</h2>
                                    <p>
                                        전통의 기술과 마음을 이어받은 곤도염색공장의 본염(本染)<br/>
                                        본염으로 일컬어지는 간단한 염색기법이 유통되어 대량 생산 가능한 기계염색이 범람하는 시대를 맞이하여 우리는 하얀 원단에 숨결을 불어넣듯이 장인이 한솔 한솔 손으로 물들여가는 솔질염색을  완고하게 지켜오고 있습니다.

                                    </p>
                                    <p>
                                        솔질 본염은 옛부터 다양한 형태로 일본인의 생활을 아름답게 꾸며온 전통공예의 문화입니다.<br/>
                                        앞면과 뒷면을 구분할 수 없울정도로 균등하게 물들이는 본염만아 가지고 있는 아름다움과 따뜻한 느낌 속에 사람들은 축하하는 마음과 기원하는 마음을 나타내왔습니다.
                                    </p>
                                    <p>
                                        보는 사람을 매혹시키는  섬세하면서도  선명한 염색<br/>
                                        깃발을 게양하는 사람과 옷을 입는 사람의 마음가짐을 전달하는 <br/>
                                        당당한 품격과 질감<br/>
                                        곤도염색공장은 염색을 통하여 사람과 사람, 마음과 마음을 잇고 있습니다.

                                    </p>
                                </div>
                                <button onClick={() => toggleTab(0)}>日本語</button>
                                <button onClick={() => toggleTab(1)}>English</button>
                                <button onClick={() => toggleTab(2)}>中文（繁体）</button>
                                <button onClick={() => toggleTab(3)}>韓国語</button>
                            </article>
                        </section>
                        <section className='article-contents'>
                            <div className='img-right'>
                                <article>
                                    <h2>下絵</h2>
                                    <p>
                                        大漁旗の下絵は、過去から積み重ねてきた図柄サンプルをもとに、1枚1枚手描きで専門の職人が描きます。力強い肉太の文字で、パソコンのフォントでは出せない迫力を表現します。<br/>
                                        文字を際立たせる絵柄も、過去からの積み重ねで現在は80種類以上。サンプルに無いオリジナルの絵柄のご希望にも添います。
                                    </p>
                                </article>
                                <img src={Articleimg_01} alt='Articleimg_01' />
                            </div>
                            <div className='img-left'>
                                <img src={Articleimg_02} alt='Articleimg_02' />
                                <article>
                                    <h2>筒描き（つつがき）・型糊置き</h2>
                                    <p>
                                        水で落ちる染料の緋紅（ひべに）で描かれた下絵の上から、防染糊を置きます。筒糊を絞り出しながら、文字や絵柄の染まらない部分（色と色の境目）に糊を置いていきます。<br/>
                                        この時点で文字や絵柄の良しあしが決まる重要な工程です。この道15年～20年以上の熟練の職人が手早く、美しい直線・曲線を描いていきます。<br/>
                                        ちょっとした角の取り方や線の揺らぎで、全体の印象が一気に変わります。ここにも、プリント染めにはない、人の手により生み出された美しさや力強さが表現されます。
                                        ロゴマークや数物の染めでは、シルクスクリーンの型を使って糊置きをします。
                                    </p>
                                </article>
                            </div>
                            <div className='img-right'>
                                <article>
                                    <h2>ひと刷毛入魂、刷毛引き本染め</h2>
                                    <p>
                                        当工場では現在、捺染（プリント染め）業者が多い中、全国でも数少ない本染め専門工場として代々から教え伝わる刷毛引き本染めを貫いています。<br/>
                                        大小の刷毛を使い分け、染料を染めていきます。宙に浮かせた状態で。、刷毛で染めるので、たっぷりと染料が生地に浸透し、裏も表と同じように鮮やかに染まります。<br/>
                                        ぼかしやグラデーションのような表現も自在です。染料は時間がたつと乾いてムラになりますので、ここでも手早く均一に染める職人の技術が光ります。<br/>
                                        3～4人の職人で一度に1枚の大漁旗を染め、多い時は1日20枚程度染めます。のれんやのぼりなど、屋外で継続的に使用するものは、色褪せしづらい顔料を使用します。
                                    </p>
                                </article>
                                <img src={Articleimg_03} alt='Articleimg_03' />
                            </div>
                            <div className='img-left'>
                                <img src={Articleimg_06} alt='Articleimg_03' />
                                <article>
                                    <h2>水元（水洗）</h2>
                                    <p>
                                        工場の作業で最後の重要な工程となる、水元（水洗）。この地旭川は大雪山の豊富で良質な伏流水のおかげで、鮮やかな発色を生み出してくれます。<br/>
                                        ここも職人の腕の見せ所です。水洗の最初には余分な染料が流れ出ますが、素早く流さないと白地に色が移ってしまいます（白場汚染）せっかくの染め物がその時点でダメになってしまうこともあり、神経を使います。日の丸は簡単そうに見えますが、実は最も白場汚染の影響を受けやすく、注意が必要な商品です。
                                    </p>
                                </article>
                            </div>
                            <div className='img-right'>
                                <article>
                                    <h2>縫製</h2>
                                    <p>
                                        最後に旗を完成形にするために縫製します。旗のほかにも棒通しのチチが付くのぼり、のれんや祭袢天など、仕立ての複雑な商品もあります。<br/>
                                        こちらも熟練の仕立て屋さんが担当し、しっかりとした美しい商品に仕上げます。縫製の良さも当社の自慢です。
                                    </p>
                                </article>
                                <img src={Articleimg_08} alt='Articleimg_08' />
                            </div>
                            <div className='youtube-content'>
                                <YTubeOrg />
                                <h4>https://www.youtube.com/watch?v=rCslPLFeiuc</h4>
                            </div>
                        </section>
                        <section className='article-bottom'>
                        </section>
                    </main>
                    <ContactButton />
                    <KondoFooter />
                </motion.div>
            </div>
        </div>
    )
}
export default PageArticle;